import { GridColDef } from "@mui/x-data-grid";

export const contactColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "phone", headerName: "Phone", flex: 1 },
  { field: "note", headerName: "Note", flex: 1 },
];
